<template>
  <div class="form-actions-cintainer">
    <svg class="drawing-item-copy" width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" @mouseleave="copyEnter = false" @mouseenter="copyEnter = true" @click.stop="copyItem">
      <title>复制</title>
      <g id="v1.1.0二期" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="表单管理-自定义表单-表单设计（交互）" transform="translate(-1048.000000, -140.000000)">
          <g id="编组-50" transform="translate(236.000000, 132.000000)">
            <g id="编组-48" transform="translate(812.000000, 8.000000)">
              <rect id="矩形" x="0" y="0" width="22" height="22" rx="4" />
              <g id="编组-51" transform="translate(3.000000, 3.000000)">
                <rect id="矩形" x="0" y="0" width="16" height="16" />
                <g id="form-path-copy" transform="translate(2.500000, 2.500000)" :fill="copyEnter ? '#2C51EF' : '#84909D'" fill-rule="nonzero">
                  <path id="形状结合" d="M9.75986842,0 C10.4019674,0 10.9300902,0.487991642 10.9935973,1.11333537 L11,1.24013158 L11,7.65460526 C11,8.2967042 10.5120084,8.82482703 9.88666463,8.88833418 L9.75986842,8.89473684 L8.894,8.894 L8.89473684,9.75986842 C8.89473684,10.4019674 8.4067452,10.9300902 7.78140148,10.9935973 L7.65460526,11 L1.24013158,11 C0.555226046,11 0,10.444774 0,9.75986842 L0,9.75986842 L0,3.34539474 C0,2.6604892 0.555226046,2.10526316 1.24013158,2.10526316 L1.24013158,2.10526316 L2.105,2.105 L2.10526316,1.24013158 C2.10526316,0.598032642 2.5932548,0.0699098163 3.21859852,0.00640266203 L3.34539474,0 L9.75986842,0 Z M7.65460526,3.10526316 L1.24013158,3.10526316 C1.1075108,3.10526316 1,3.21277395 1,3.34539474 L1,3.34539474 L1,9.75986842 C1,9.8924892 1.1075108,10 1.24013158,10 L1.24013158,10 L7.65460526,10 C7.78722605,10 7.89473684,9.8924892 7.89473684,9.75986842 L7.89473684,9.75986842 L7.89473684,3.34539474 C7.89473684,3.21277395 7.78722605,3.10526316 7.65460526,3.10526316 L7.65460526,3.10526316 Z M9.75986842,1 L3.34539474,1 C3.23487742,1 3.14179759,1.07466027 3.11384091,1.17629517 L3.10526316,1.24013158 L3.105,2.105 L7.65460526,2.10526316 C8.2967042,2.10526316 8.82482703,2.5932548 8.88833418,3.21859852 L8.89473684,3.34539474 L8.894,7.894 L9.75986842,7.89473684 C9.87038574,7.89473684 9.96346557,7.82007657 9.99142225,7.71844167 L10,7.65460526 L10,1.24013158 C10,1.12961426 9.92533973,1.03653443 9.82370483,1.00857775 L9.75986842,1 Z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
    <svg class="drawing-item-delete" width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" @mouseleave="deleteEnter = false" @mouseenter="deleteEnter = true" @click.stop="deleteItem">
      <title>删除</title>
      <g id="v1.1.0二期" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="表单管理-自定义表单-表单设计（交互）" transform="translate(-1074.000000, -140.000000)">
          <g id="编组-50" transform="translate(236.000000, 132.000000)">
            <g id="编组-49" transform="translate(838.000000, 8.000000)">
              <rect id="矩形备份-5" x="0" y="0" width="22" height="22" rx="4" />
              <g id="编组-52" transform="translate(3.000000, 3.000000)">
                <rect id="矩形" x="0" y="0" width="16" height="16" />
                <g id="form-path-delete" transform="translate(3.000000, 2.500000)" :fill="deleteEnter ? '#F53F3F' : '#84909D'" fill-rule="nonzero">
                  <path id="形状结合" d="M6.194275,0 C6.37839869,0 6.54762343,0.101193752 6.63475147,0.263398063 L6.63475147,0.263398063 L7.299,1.5 L10,1.5 L10,2.5 L9.25,2.5 L9.25,10.5 C9.25,10.7454599 9.07312484,10.9496084 8.83987563,10.9919443 L8.75,11 L1.25,11 C0.973857625,11 0.75,10.7761424 0.75,10.5 L0.75,10.5 L0.75,2.5 L0,2.5 L0,1.5 L2.703,1.5 L3.38380306,0.259658 C3.45694633,0.126225459 3.58585704,0.0348624307 3.73246565,0.00811454748 L3.82225,0 Z M8.249,2.5 L1.75,2.5 L1.75,10 L8.249,10 L8.249,2.5 Z M4.5,4.5 L4.5,7.75 L3.5,7.75 L3.5,4.5 L4.5,4.5 Z M6.5,4.5 L6.5,7.75 L5.5,7.75 L5.5,4.5 L6.5,4.5 Z M5.895,1 L4.118,1 L3.844,1.499 L6.163,1.499 L5.895,1 Z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      copyEnter: false,
      deleteEnter: false
    }
  },
  methods: {
    copyItem() {
      this.$emit('copy', this.index)
    },
    deleteItem() {
      this.$emit('delete', this.index)
    }
  }
}
</script>

<style lang="scss" scoped>
  .form-actions-cintainer {
    position: absolute;
    right: 0px;
    top: 0px;
    svg {
      cursor: pointer;
    }
  }
</style>
